import { GlobalFooter } from "common/GlobalFooter";
import { GlobalNav } from "common/GlobalNav";
import { clubApi } from "data/resources/clubs";
import { LayoutTop } from "features/organizations_legacy/Layout";
import { base } from "lib/styleguide/base.scss";
import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";

const _OrganizationLayout = ({ children, match }) => {
  const [{ club, layoutConfig }, setClubAndLayoutConfig] = useState({});

  useEffect(() => {
    const clubId = parseInt(match.params?.clubIdParam, 10);
    clubApi.read(clubId).then(({ club, meta: { layoutConfig } }) => {
      setClubAndLayoutConfig({ club, layoutConfig });
    });
  }, []);

  return (
    <div className={base}>
      <GlobalNav />
      {club && (
        <>
          <LayoutTop params={match.params} organization={club} {...layoutConfig} />
          {children}
        </>
      )}
      <GlobalFooter />
    </div>
  );
};

export const OrganizationLayout = withRouter(_OrganizationLayout);
